import React from "react"
import { BarLoader } from "react-spinners"

export default function Loader({ loading = true, containerClasses = "" }) {
  return (
    <div className={`${containerClasses}`}>
      <BarLoader color="#0a71fa" loading={loading} height={4} width="100%" />
    </div>
  )
}